var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "facebook-pixel-page"
  }, [_c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "d-flex justify-content-between align-items-center flex-wrap",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', [_c('h2', {
    staticClass: "page-title mb-50"
  }, [_vm._v("Facebook Pixel Manager")]), _c('p', {
    staticClass: "page-subtitle mb-0"
  }, [_vm._v(" Standalone Facebook Pixel + optional CAPI configuration. Only one active config works at a time. ")])])])], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "xl": "5",
      "lg": "5"
    }
  }, [_c('b-card', {
    staticClass: "pixel-card mb-2"
  }, [_c('div', {
    staticClass: "mb-2"
  }, [_c('h4', {
    staticClass: "mb-25"
  }, [_vm._v(_vm._s(_vm.editMode ? 'Edit Pixel' : 'Add New Pixel'))]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Pixel ID required, Access Token and Test Event Code optional.")])]), _c('b-form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.submitForm($event);
      }
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Name"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Example: Main Pixel",
      "required": ""
    },
    model: {
      value: _vm.form.name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "name", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "form.name"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Pixel ID"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Example: 123456789012345",
      "required": ""
    },
    model: {
      value: _vm.form.pixel_id,
      callback: function ($$v) {
        _vm.$set(_vm.form, "pixel_id", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "form.pixel_id"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Access Token (Optional)"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "placeholder": "For Conversion API",
      "rows": "3"
    },
    model: {
      value: _vm.form.access_token,
      callback: function ($$v) {
        _vm.$set(_vm.form, "access_token", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "form.access_token"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Test Event Code (Optional)"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Example: TEST12345"
    },
    model: {
      value: _vm.form.test_event_code,
      callback: function ($$v) {
        _vm.$set(_vm.form, "test_event_code", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "form.test_event_code"
    }
  })], 1), _c('div', {
    staticClass: "d-flex flex-wrap gap-1"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "primary",
      "disabled": _vm.submitting
    }
  }, [_vm._v(" " + _vm._s(_vm.submitting ? _vm.editMode ? 'Updating...' : 'Saving...' : _vm.editMode ? 'Update Pixel' : 'Save Pixel') + " ")]), _c('b-button', {
    attrs: {
      "type": "button",
      "variant": "outline-secondary",
      "disabled": _vm.submitting
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v(" Reset ")]), _vm.editMode ? _c('b-button', {
    attrs: {
      "type": "button",
      "variant": "outline-danger",
      "disabled": _vm.submitting
    },
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v(" Cancel Edit ")]) : _vm._e()], 1)], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "xl": "7",
      "lg": "7"
    }
  }, [_c('b-card', {
    staticClass: "pixel-card mb-2"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center flex-wrap mb-2"
  }, [_c('div', [_c('h4', {
    staticClass: "mb-25"
  }, [_vm._v("Saved Pixels")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Multiple configs can be stored, but only one remains active.")])]), _c('div', {
    staticClass: "d-flex flex-wrap gap-1"
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-warning",
      "size": "sm",
      "disabled": _vm.deactivatingAll || _vm.loading
    },
    on: {
      "click": _vm.deactivateAll
    }
  }, [_vm._v(" " + _vm._s(_vm.deactivatingAll ? 'Processing...' : 'Deactivate All') + " ")]), _c('b-button', {
    attrs: {
      "variant": "outline-primary",
      "size": "sm",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.loadPixels
    }
  }, [_vm._v(" Refresh ")])], 1)]), _vm.loading ? _c('div', {
    staticClass: "loading-wrap"
  }, [_vm._v(" Loading pixels... ")]) : _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table pixel-table mb-0"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _c('th', [_vm._v("Pixel ID")]), _c('th', [_vm._v("CAPI")]), _c('th', [_vm._v("Test Code")]), _c('th', [_vm._v("Status")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Action")])])]), _c('tbody', [_vm._l(_vm.pixels, function (item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_c('div', {
      staticClass: "font-weight-bold"
    }, [_vm._v(_vm._s(item.name))])]), _c('td', [_c('span', {
      staticClass: "mono"
    }, [_vm._v(_vm._s(item.pixel_id))])]), _c('td', [_c('b-badge', {
      attrs: {
        "variant": item.access_token ? 'success' : 'light'
      }
    }, [_vm._v(" " + _vm._s(item.access_token ? 'Enabled' : 'Not Set') + " ")])], 1), _c('td', [item.test_event_code ? _c('span', {
      staticClass: "mono"
    }, [_vm._v(" " + _vm._s(item.test_event_code) + " ")]) : _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("�")])]), _c('td', [_c('b-badge', {
      attrs: {
        "pill": "",
        "variant": item.is_active ? 'success' : 'secondary'
      }
    }, [_vm._v(" " + _vm._s(item.is_active ? 'Active' : 'Inactive') + " ")])], 1), _c('td', {
      staticClass: "text-right"
    }, [_c('div', {
      staticClass: "d-flex justify-content-end flex-wrap gap-1"
    }, [_c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "outline-primary"
      },
      on: {
        "click": function ($event) {
          return _vm.startEdit(item);
        }
      }
    }, [_vm._v(" Edit ")]), !item.is_active ? _c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "outline-success",
        "disabled": _vm.activatingId === item.id
      },
      on: {
        "click": function ($event) {
          return _vm.activatePixel(item.id);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.activatingId === item.id ? 'Activating...' : 'Activate') + " ")]) : _c('b-badge', {
      staticClass: "d-flex align-items-center px-1",
      attrs: {
        "variant": "success"
      }
    }, [_vm._v(" Running ")]), _c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "outline-danger",
        "disabled": _vm.deletingId === item.id
      },
      on: {
        "click": function ($event) {
          return _vm.deletePixel(item);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.deletingId === item.id ? 'Deleting...' : 'Delete') + " ")])], 1)])]);
  }), !_vm.pixels.length ? _c('tr', [_c('td', {
    staticClass: "text-center text-muted py-3",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v(" No Facebook Pixel configuration found ")])]) : _vm._e()], 2)])])]), _c('b-card', {
    staticClass: "pixel-card mb-2"
  }, [_c('div', {
    staticClass: "mb-2"
  }, [_c('h4', {
    staticClass: "mb-25"
  }, [_vm._v("How It Works")])]), _c('ul', {
    staticClass: "info-list mb-0"
  }, [_c('li', [_vm._v("Only one pixel can stay active at a time.")]), _c('li', [_vm._v("You can keep all records inactive if you do not want any standalone pixel running.")]), _c('li', [_vm._v("Frontend tracker sends Pixel browser events automatically when a config is active.")]), _c('li', [_vm._v("If Access Token is added, backend also sends CAPI events.")]), _c('li', [_vm._v("Legacy pixel-code manager remains untouched.")])])])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }